import LogRocket from 'logrocket';
import { LOG_ROCKET_APP_ID, LOG_ROCKET_ENABLED } from '~/config';
import { createLogRocketSanitizers, LOG_ROCKET_DOM_OPTIONS } from './replay-privacy';
import { scrubUrl } from './link-token';

if( LOG_ROCKET_ENABLED ) {
	// LogRocket keeps every XHR and fetch body unless told otherwise; the sanitizers redact the
	// ones that carry a credential. See `replay-privacy.js`. The page URL is recorded too, and
	// a bearer token in it is replaced -- belt to `hide-link-token`, which has already moved it
	// out of the address bar by the time this runs. See `link-token.js`.
	LogRocket.init(LOG_ROCKET_APP_ID, {
		network: createLogRocketSanitizers(),
		dom: LOG_ROCKET_DOM_OPTIONS,
		browser: { urlSanitizer: scrubUrl }
	});
}
